import {
  GET_CONTACT_SUCCESS
} from '../mutation-types'

// initial state
const state = {
  contacts: {},
  status: {
    getUser: {}
  }
}

// getters
const getters = {
  contact: function (state) {
    return function (contactId) {
      return state.contacts[contactId]
    }
  }
}

// mutations
const mutations = {
  [GET_CONTACT_SUCCESS]: function (state, data) {
    state.contacts = {...state.contacts, [data.contactId]: data}
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contacts.js